// extracted by mini-css-extract-plugin
export default {"markdown":"f38c0b","markdown_picture":"ae2fd9","markdown_image":"dace3c","markdown_audio":"faea12","markdown_video":"a0d3e2"};